import { useLayoutEffect } from "react"
import { UseFormReturn } from "react-hook-form"
import { useLens } from "@hookform/lenses"
import { useProgressNoteFormContext } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { useStoreFormEffect } from "@/modules/patients/detail/progress-note/hooks/useStoreFormEffect"
import { StoreFormState } from "@/modules/patients/detail/progress-note/hooks/useStoreFormState"
import { AssignEpisodeOfCareFormType } from "@/modules/patients/detail/progress-note/progress-note-card-header"
import { EpisodeOfCareProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"

export const useAssignEpisodeOfCareFormEffect = (
  id: string,
  appointmentId: string,
  episodeOfCareProgressNoteData: EpisodeOfCareProgressNoteData,
  storeFormState: StoreFormState,
  form: UseFormReturn<AssignEpisodeOfCareFormType>,
  isProgressNoteEditable: boolean,
  isEditWithin24HoursAfterCloseMode: boolean,
) => {
  const setProgressNoteForm = useProgressNoteFormContext((state) => state.setProgressNoteForm)
  const inContextOfAppointmentId = useAppointmentParam()

  const lens = useLens({ control: form.control })

  useStoreFormEffect(storeFormState, form, lens.focus("formIsDirty"))

  useLayoutEffect(() => {
    if (appointmentId === inContextOfAppointmentId && (isProgressNoteEditable || isEditWithin24HoursAfterCloseMode)) {
      setProgressNoteForm(id, episodeOfCareProgressNoteData, { kind: "AssignEpisodeOfCare", data: form })
    }
  }, [
    id,
    episodeOfCareProgressNoteData,
    form,
    setProgressNoteForm,
    appointmentId,
    inContextOfAppointmentId,
    isProgressNoteEditable,
    isEditWithin24HoursAfterCloseMode,
  ])
}
